import { Button, Grid, Stack } from '@mui/material';
import React from 'react';

import { LogoGithub } from '@carbon/icons-react';
import { GITHUB_USERNAME, My } from '../../../../data/My';
import Projects from '../../../../data/Projects';
import type { DevProject } from '../../../../utils/Types';
import DevProjectCard from './DevProjectCard';

const DevProjectsView = () => {
    return (
        <>
            <Stack sx={{ alignItems: { xs: 'center', md: 'flex-start' } }}>
                <Button
                    aria-label="portfolio button"
                    href={My.portfolio}
                    target="_blank"
                    startIcon={<LogoGithub />}
                >
                    {GITHUB_USERNAME}/portfolio
                </Button>
            </Stack>

            <div className="dev-projects-view">
                <Grid
                    container
                    direction="row"
                    spacing="15px"
                    sx={{
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                    }}
                >
                    {Projects.get('dev').map((p, i) => (
                        <DevProjectCard project={p as DevProject} key={i} />
                    ))}
                </Grid>
            </div>
        </>
    );
};

export default DevProjectsView;
